import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import { useEffect, useState } from 'react';
import formatCurrency from '../utils/formatCurrency';
import FailedLoadingScreen from './FailedLoadingScreen';
import LoadingScreen from './LoadingScreen';

const PurchaseOrderLines = ({
  poLines,
  isLoading,
  editable,
  error,
  onRowUpdate,
  ...rest
}) => {
  /**
   * Sample Purchase Order Line Item...
   *
   * {
   *  "LineNum": 0,
   *  "Description": "Pre employment Medical exam - Mmelesi expires 23/07/2024 (1 x 1060,87)",
   *  "Quantity": ".000000",
   *  "UnitPrice": "1060.870000",
   *  "LineTotal": "1060.870000",
   *  "LineStatus": "O",
   *  "LineFormatCode": "13430103017605"
   * }
   */
  const [selectedLinesByRow, setSelectedLinesByRow] = useState({});
  const [userChanged, setUserChanged] = useState(false);
  const [localPoLines, setLocalPoLines] = useState(poLines || []);
  const vatGroups = [
    {
      name: 'I0 - Exempt from Input VAT',
      code: 'I0',
      rate: 0,
    },
    {
      name: 'I1 - 15% Input VAT',
      code: 'I1',
      rate: 0.15,
    },
    {
      name: 'I2 - 15% Capital Input VAT',
      code: 'I2',
      rate: 0.15,
    },
    {
      name: 'I3 - Zero Rated Input VAT',
      code: 'I3',
      rate: 0,
    },
    {
      name: 'I4 - Non-Claimable Input VAT',
      code: 'I4',
      rate: 0,
    },
    {
      name: 'I5 - 9% Input VAT',
      code: 'I5',
      rate: 0.09,
    },
    {
      name: 'I7 - 8.4% Input VAT',
      code: 'I7',
      rate: 0.084,
    },
  ];

  const columns = [
    {
      name: 'LineFormatCode',
      header: 'Code',
      defaultVisible: false,
      defaultFlex: 1,
      sortable: false,
    },
    {
      name: 'Description',
      header: 'Description',
      defaultFlex: 4,
      sortable: false,
    },
    {
      name: 'PONumber',
      header: 'PO Number',
      defaultFlex: 4,
      sortable: false,
    },
    {
      name: 'PODocNum',
      header: 'PO Doc Entry',
      defaultFlex: 4,
      sortable: false,
    },
    {
      name: 'UnitPrice',
      header: 'Unit Price',
      render: ({ value }) => formatCurrency(value),
      defaultFlex: 3,
      textAlign: 'end',
      headerAlign: 'center',
      sortable: false,
    },
    {
      name: 'LineTotal',
      header: 'Line Total',
      render: ({ value }) => formatCurrency(value),
      defaultFlex: 3,
      textAlign: 'end',
      headerAlign: 'center',
      sortable: false,
    },
    {
      name: 'LineStatus',
      header: 'Line Status',
      defaultFlex: 3,
      textAlign: 'center',
      sortable: false,
    },
    {
      name: 'ReceivedTotal',
      header: 'Received Total',
      defaultFlex: 4,
      render: ({ value, data }) => (
        <InputText
          value={value ?? 0}
          disabled={data.LineStatus === 'C' || !editable}
          onChange={(e) => {
            if (userChanged == false) {
              setSelectedLinesByRow((prev) => ({
                ...prev,
                [data.LineNum]: [],
              }));
            }
            const updatedRow = { ...data, ReceivedTotal: e.target.value };
            console.log('Row update: ', updatedRow, typeof onRowUpdate);
            if (typeof onRowUpdate === 'function') {
              onRowUpdate(updatedRow, poLines);
            }
          }}
          onInput={(e) => {
            setUserChanged(true); // ✅ user is typing
          }}
        />
      ),
      textAlign: 'end',
      headerAlign: 'center',
      sortable: false,
    },
    /*{
      name: 'Matches',
      header: 'Matches Invoice',
      render: ({ value, data }) => (
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => {
            const updatedRow = { ...data, Matches: e.target.checked };

            if (typeof onRowUpdate === 'function') {
              onRowUpdate(updatedRow);
            }
          }}
        />
      ),
      defaultFlex: 1,
      textAlign: 'center',
      sortable: false,
    },
    {
      name: 'MatchedInvoiceLines',
      header: 'Matched Invoice Lines',
      defaultFlex: 5,
      render: ({ value, data }) => {
        return (
          <MultiSelect
            display="chip"
            value={selectedLinesByRow[data.LineNum]}
            disabled={data.LineStatus === 'C' || !editable}
            onChange={(e) => {
              setUserChanged(false);
              const selected = e.value;
              console.log('On change value and data: ', value, data);
              // Store selection temporarily in state (not in DB)
              setSelectedLinesByRow((prev) => ({
                ...prev,
                [data.LineNum]: selected,
              }));

              // use reduce() method to find the sum
              var total = selected.reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
              }, 0);
              total = Number(total.toFixed(2));

              console.log('Selected:', selected, 'Total:', total);
              const updatedRow = { ...data, ReceivedTotal: total };
              console.log('Row update: ', updatedRow, typeof onRowUpdate);
              if (typeof onRowUpdate === 'function') {
                onRowUpdate(updatedRow, poLines);
              }
            }}
            optionLabel="LineTotal"
            optionValue="LineTotal"
            className="w-full md:w-20rem"
            placeholder="Select Invoice Lines"
            options={expenseRows}
          />
        );
      },
      textAlign: 'center',
      sortable: false,
    },*/
    {
      name: 'VatGroup',
      header: 'Vat Group',
      render: ({ value, data }) => {
        return (
          <Dropdown
            value={value}
            disabled={data.LineStatus === 'C' || !editable}
            onChange={(e) => {
              console.log('Event: ', e);
              console.log('Current Data: ', data, value);
              const updatedRow = { ...data, VatGroup: e.target.value };
              console.log('Updated Row: ', updatedRow);
              if (typeof onRowUpdate === 'function') {
                onRowUpdate(updatedRow, poLines);
              }
            }}
            options={vatGroups}
            optionLabel="name"
            optionValue="code"
            className="w-full md:w-14rem"
          />
        );
      },
      defaultFlex: 5,
      textAlign: 'center',
      sortable: false,
    },
  ];

  useEffect(() => {
    setLocalPoLines(poLines || []);
  }, [poLines]);

  const getRowClassName = ({ data }) => {
    return data.LineStatus === 'C' ? 'row-disabled' : '';
  };

  if (isLoading) {
    return (
      <LoadingScreen
        message="Loading purchase order..."
        description="Juice is fetching latest purchase order details. Please wait..."
        height="300px"
      />
    );
  }

  if (error) {
    return (
      <div {...rest}>
        <FailedLoadingScreen
          title="Failed to load purchase order"
          description="Juice failed to fetch purchase order details. Please try again."
          height="300px"
          showRetryButton={false}
        />
      </div>
    );
  }

  return (
    <div {...rest}>
      <ReactDataGrid
        idProperty="id"
        columns={columns}
        rowClassName={getRowClassName}
        dataSource={localPoLines}></ReactDataGrid>
    </div>
  );
};

export default PurchaseOrderLines;
